import { render, staticRenderFns } from "./ClienteAduana.vue?vue&type=template&id=36d4efa8&"
import script from "./ClienteAduana.vue?vue&type=script&lang=js&"
export * from "./ClienteAduana.vue?vue&type=script&lang=js&"
import style0 from "./ClienteAduana.vue?vue&type=style&index=0&id=36d4efa8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports